import {FETCH_NOTIFICATIONS_SETTINGS_CONFIG_COMPS, FETCH_NOTIFICATIONS_SETTINGS_TABLE_DATA, FETCH_NOTIFICATION_SETTINGS_CONFIG_DETAIL,
    FETCH_ALL_WEB_NOTIFICATIONS, FETCH_NOTIFICATION_STATUS_WISE_COUNT,FETCH_WEB_NOTIFICATIONS_UNREAD_COUNT
} from "../types"

const INIT_STATE = {
    notificationsSettingsTableData: [],
    notificationSettingsTableDataRows: 0,
    notificationsSettingsConfigComps: [],
    notificationsSettingsConfigCompsRows: 0,
    notificationSettingConfigDetailData:null,
    allWebNotificationsList: [],
    notificationStatusWiseCount:{}



}
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_NOTIFICATIONS_SETTINGS_CONFIG_COMPS: return { ...state, notificationsSettingsConfigComps: action?.payload?.data || [], notificationsSettingsConfigCompsRows: action?.payload?.count || 0 }
        case FETCH_NOTIFICATIONS_SETTINGS_TABLE_DATA: return { ...state, notificationsSettingsTableData: action?.payload?.data || [], notificationSettingsTableDataRows: action?.payload?.count || 0 }
        case FETCH_NOTIFICATION_SETTINGS_CONFIG_DETAIL: return { ...state, notificationSettingConfigDetailData: action?.payload}
        case FETCH_ALL_WEB_NOTIFICATIONS: return { ...state, allWebNotificationsList: action?.payload || []}
        case FETCH_NOTIFICATION_STATUS_WISE_COUNT: return { ...state, notificationStatusWiseCount: action?.payload}
        case FETCH_WEB_NOTIFICATIONS_UNREAD_COUNT: return { ...state, notificationStatusWiseCount: action?.payload?.data || {} }


        default: return state
    }
}